import { combineReducers } from 'redux';
import { currencyOfferSlice } from '~/pages/ShopSaga/CurrencyOffer/currencyOfferSlice';
import { exclusiveOfferSlice } from '~/pages/ShopSaga/ExclusiveOffer/exclusiveOfferSlice';
import { specialOfferSlice } from '~/pages/ShopSaga/SpecialOffer/specialOfferSlice';
import { tradeDealSlice } from '~/pages/ShopSaga/TradeDeal/tradeDealSlice';

export const shopSagaReducers = combineReducers({
    currencyOffer: currencyOfferSlice.reducer,
    exclusiveOffer: exclusiveOfferSlice.reducer,
    specialOffer: specialOfferSlice.reducer,
    tradeDeal: tradeDealSlice.reducer,
});
